// import isEqual from 'lodash/isEqual';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React, { useEffect, useState } from "react";
import { Navigation } from './Navigation'; 
import Train from "./components/Train";
import Primary from './components/Primary';
// import { Footer } from './components/Footer';
import TrainerCreate from './components/TrainerCreate';
import TrainerMy  from './components/TrainerMy';
import TrainerEdit from "./components/TrainerEdit";
import './style.css';
import MyDescriptions from "./components/MyDescriptions";
import DescEdit from "./components/DescEdit";
import DescEditor from "./components/DescEditor";
import Profile from "./components/Profile";
import MapPage from "./components/MapPage";
import Statistics from "./pages/Statistics";

import Footer from "./components/Footer";
import { Test } from "./components/Test";
import NewSub from "./components/NewSub";
import MySubs from "./components/MySubs";
import EditSubs from "./components/EditSubs";
// import NewSub from "./components/MySub";

// import { Test } from "./components/Test";
import Login from "./components/Login";
import AboutPage from "./components/AboutPage";
import  Register  from "./components/Register";
// import { Profile } from "./components/Profile";
// import { MoreUser } from "./components/moreUser";
// import { Yakuniy } from "./components/Yakuniy";
// import { Felina } from "./components/Felina";
// import { CourseComment } from "./components/CourseComment";

// import { ProtectedRoute } from './components/ProtectedRoute';
// import { Dashboard } from './components/Dashboard';
// import { AuthProvider, useAuth } from './context/AuthContext';
// import i18n from './i18n';
// import { ScrollToTop } from './ScrollToTop';
// import { TranslationProvider } from "./components/TranslationContext";
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

import MyWrittenQuestions from "./components/MyWrittenQuestions";
import CreateWrittenQuestion from "./components/CreateWrittenQuestion";
import EditWrittenQuestion from "./components/EditWrittenQuestion";
import { UserRolesManager } from "./components/UserRolesManager";

  export const App = () => {

    
      
    return (
      <>
      {/* <ToastContainer position="top-right" autoClose={3000} />
      <TranslationProvider>
      <ScrollToTop />
      <AuthProvider> */}
      
        <div className="main">
          <Navigation />
          
            <Routes>
                <Route path="/" element={<Primary />} />
                <Route path="/Train/:id" element={<Train />} />
                <Route path="/test/:kursId" element={<Test />} />
                <Route path="/test/:kursId/:savolId" element={<Test />} />
                <Route path="/TrainerCreate" element={<TrainerCreate />} />
                <Route path="/TrainerMy" element={<TrainerMy />} />
                <Route path="/TrainerEdit/:id" element={<TrainerEdit />} />
                {/* <Route path="/themes/:id" element={<Themes />} />
                <Route path="/courseComment/:id" element={<CourseComment />} />
                <Route path="/lesson/:kursId/:id" element={<Lesson />} /> */}
                <Route path="/about" element={<AboutPage />} />
                <Route path="/profile" element={<Profile />} />
                
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/MyDescriptions" element={<MyDescriptions />} />
                <Route path="/DescEdit/:id" element={<DescEdit />} />
                <Route path="/desc/:id" element={<DescEditor />} />
                <Route path="/statistics" element={<Statistics />} />
                <Route path="/mappage/:id" element={<MapPage />} />
                <Route path="/YangiFan" element={<NewSub />} />
                <Route path="/MeningFanlarim" element={<MySubs />} />
                <Route path="/EditSubs/:id" element={<EditSubs />} />
                <Route path="/YozmaQishloq" element={<MyWrittenQuestions />} />
                <Route path="/MyQuestions" element={<MyWrittenQuestions />} />
                <Route path="/CreateWrittenQuestion" element={<CreateWrittenQuestion />} />
                <Route path="/NewQuestion" element={<CreateWrittenQuestion />} />
                <Route path="/editQuestion/:id" element={<EditWrittenQuestion />} />
                <Route path="/user-roles" element={<UserRolesManager />} />
                {/* <Route path="/yakuniy/:kursId" element={<Yakuniy />} />  */}

                {/* <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                /> */}
            </Routes>
          
  
          <Footer />
        </div>
      {/* </AuthProvider>
      </TranslationProvider> */}
      </>
    );
  };
